module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO25 PresupuestoMensualOtrosIngresos.e67bd39.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO25 PresupuestoMensualOtrosIngresos.mp4
// module id = 751
// module chunks = 1